const IconProfile = ({ width = 24, height = 25, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 18.4766C4 17.4157 4.42143 16.3983 5.17157 15.6481C5.92172 14.898 6.93913 14.4766 8 14.4766H16C17.0609 14.4766 18.0783 14.898 18.8284 15.6481C19.5786 16.3983 20 17.4157 20 18.4766C20 19.007 19.7893 19.5157 19.4142 19.8908C19.0391 20.2658 18.5304 20.4766 18 20.4766H6C5.46957 20.4766 4.96086 20.2658 4.58579 19.8908C4.21071 19.5157 4 19.007 4 18.4766Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.4766C13.6569 10.4766 15 9.13342 15 7.47656C15 5.81971 13.6569 4.47656 12 4.47656C10.3431 4.47656 9 5.81971 9 7.47656C9 9.13342 10.3431 10.4766 12 10.4766Z"
        stroke={fill}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default IconProfile;
